import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Grid, Paper, Typography } from '@material-ui/core';

import { useStyles } from './styles';

import * as session from '../../utils/session';
import SelectOption from '../../components/SelectOption';
import ROUTES_NAME from '../../consts/routes-name';
import { usePartner } from '../../context/PartnerContext';
import { AutenticationActions } from '../../store/ducks/autentication';
import ReactGTM from '../../utils/gtm';
import {
  getTipoPessoaFromDocument,
  telefoneMascarado,
} from '../../utils/normalizers/normalizers';

export default function SelecaoEnvioCodigoPrimeiroAcesso() {
  const classes = useStyles();
  const navigate = useNavigate();
  const { screens } = usePartner();
  const { texts } = screens.selecaoEnvioCodigoPrimeiroAcesso;

  const { dadosMascarados } = useSelector((state) => ({
    dadosMascarados: state.autenticacao?.dadosMascarados,
  }));

  const dispatch = useDispatch();
  const userName = session.getUserNamePrimeiroAcesso();

  useEffect(() => {
    if (!dadosMascarados && userName) {
      dispatch(
        AutenticationActions.getDadosMascaradosRequest({
          cpfCnpj: userName,
          isPrimeiroAcesso: true,
          tipoPessoa: getTipoPessoaFromDocument(userName),
        }),
      );
      window.history.replaceState({}, null);
    }
  }, [dispatch, userName, dadosMascarados]);

  useEffect(() => {
    const userNamePrimeiroAcesso = session.getUserNamePrimeiroAcesso();
    if (!userNamePrimeiroAcesso) {
      navigate(ROUTES_NAME.HOME);
    }
  }, [navigate]);

  useEffect(() => {
    ReactGTM.customData('receber-codigo-acesso');
  }, []);

  return (
    <Grid
      container
      className={classes.root}
      justifyContent="center"
      alignItems="center"
    >
      <Grid
        square
        elevation={0}
        component={Paper}
        className={classes.containerGrid}
        container
        spacing={2}
        direction="row"
      >
        <Grid item xs={12}>
          <Typography variant="h2" className={classes.titulo}>
            {texts.title}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h3" className={classes.subTitulo}>
            {dadosMascarados?.telefone
              ? texts.subtitleWithPhone
              : texts.subtitleEmailOnly}
          </Typography>
        </Grid>
        <SelectOption
          isPrimeiroAcesso
          email={dadosMascarados?.email}
          celular={telefoneMascarado(dadosMascarados?.telefone)}
          onSubmitSelectCard={(value) => {
            dispatch(
              AutenticationActions.postEnviarCodigoPrimeiroAcessoRequest({
                cpfCnpj: userName,
                tipoEnvio: value?.toUpperCase(),
                tipoPessoa: getTipoPessoaFromDocument(userName),
              }),
            );
          }}
        />
      </Grid>
    </Grid>
  );
}
